import { FC } from "react";
import { useTranslation } from "react-i18next";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import styles from "./VisualizacaoBloqueadosModal.module.scss";

interface IVisualizacaoBloqueadosModal {
  visible: boolean;
  onConfirm: () => void;
  onClose: () => void;
  hasPermission: boolean;
}

const VisualizacaoBloqueadosModal: FC<IVisualizacaoBloqueadosModal> = ({
  visible,
  onConfirm,
  onClose,
  hasPermission,
}) => {

  const { t } = useTranslation(['listagemArquivos', 'common']);

  const buttons = () => {
    if (hasPermission) {
      return (
        <div className={styles['footer-buttons']}>
          <Button
            onClick={onClose}
            className={styles['cancel-button']}
          >
            {t('common:cancel')}
          </Button>
          <Button
            type="primary"
            onClick={onConfirm}
            className={styles['confirm-button']}
          >
            {t('listagemArquivos:viewFile.viewFile')}
          </Button>
        </div>
      )
    }
    return (
      <div className={styles['footer-buttons']}>
        <Button
          type="text"
          onClick={onClose}
          className={styles['cancel-button-not-permission']}
        >
          {t('common:close')}
        </Button>
      </div>
    )
  };

  return (
    <Modal
      title={hasPermission ? t('common:attention') : t('listagemArquivos:viewFile.blockedTitle')}
      width={487}
      visible={visible}
      onCancel={onClose}
      footerButtons={buttons()}
    >
      <div className={styles['main-wrapper']}>
        <p>
          {hasPermission
            ? t('listagemArquivos:viewFile.blockedWithPermission')
            : t('listagemArquivos:viewFile.blockedWithoutPermission')
          }
        </p>
        <p>
          {hasPermission
            ? t('listagemArquivos:viewFile.continueQuestion')
            : t('listagemArquivos:viewFile.contactResponsible')
          }
        </p>
      </div>
    </Modal>
  )
}

export default VisualizacaoBloqueadosModal;
